<mat-form-field *ngIf="this.fControl"
                appearance="outline"
                class="w-100"
                [ngClass]="{'has-content' : this.fControl && this.fControl.value}">

  <mat-label>ESTADO </mat-label>

  <mat-select [formControl]="fControl">
    <mat-option *ngFor="let state of states"
                [value]="state.enum">
      {{state.descricao}}
    </mat-option>
  </mat-select>

</mat-form-field>
